const Images = {
    ERROR_MAIN: require('./img/error.png'),
    WARNING_MAIN: require('./img/warning.png'),
    INFO_MAIN: require('./img/info.png'),
    ERROR_RZD: require('./img/error-old.png'),
    WARNING_RZD: require('./img/warning-old.png'),
    INFO_RZD: require('./img/info-old.png'),
};


export default Images;